import styles from './Card.module.css';

/**
 * The standard surface: slate background, hairline border, soft lift.
 *
 * padding:  'md' (default) | 'lg' | 'sm'
 * elevated: raised shadow, for popovers and hero panels
 * gradient: subtle slate→steel wash, used by the accuracy hero and result card
 * radius:   'lg' (default) | 'xl'
 */
export function Card({
  padding = 'md',
  elevated = false,
  gradient = false,
  radius = 'lg',
  as: Tag = 'div',
  className = '',
  children,
  ...rest
}) {
  const classes = [
    styles.card,
    styles[`p-${padding}`],
    styles[`r-${radius}`],
    elevated && styles.elevated,
    gradient && styles.gradient,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  );
}
